// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col {
  border-right: 1px solid #eee;
  padding: 0.5em;
  height: 100%;
  word-wrap: break-word;
  align-items: center;
  vertical-align: middle;
}

.data-row {
  font-size: 0.9em;
  border-bottom: 1px solid #eee;
}

div.row-header {
  border-top: 1px solid #ddd;
  margin-top: 0.75em;
  margin-bottom: 0;
}
div.row-header .col {
  font-weight: 600;
  border-color: #ddd;
}

.in-list {
  width: 100%;
  font-weight: 500;
  margin-bottom: 0;
  margin-top: 5px;
}

.list-sub-item {
  margin-left: 0.25em;
  font-weight: 500;
}

div.btn-container.labeled {
  padding-top: 20px;
}
div.btn-container.labeled-sm {
  padding-top: 25px;
}
div.btn-container.right {
  float: right;
  margin-left: 15px;
}
div.btn-container.left {
  float: left;
  margin-right: 15px;
}

.ui-paginator-page {
  padding: 0 !important;
}

:host ::ng-deep .ui-dataview .ui-dataview-header {
  border: none;
}
:host ::ng-deep .ui-dataview-content.ui-widget-content {
  border-width: 1px 0 0 0;
  padding: 0 0 0.5em 0;
}
:host ::ng-deep .ui-dataview-header.ui-widget-header.ui-corner-top {
  border-left: 0px;
  border-right: 0px;
  padding: 0.5em 0 0 0;
}
:host ::ng-deep .ui-paginator-bottom {
  border: 0;
}

.d-sort:hover {
  cursor: pointer;
}

.selected-col {
  background-color: #007ad9;
  color: white !important;
}

.pi-sort, .pi-sort-up, .pi-sort-down {
  margin-left: 0.5vh;
}

.pi-sort:hover {
  cursor: pointer;
  color: #000000;
}

.d-center {
  display: flex;
  align-items: center;
}

tr:hover {
  background-color: #330aea;
  color: white;
}

td, th {
  border: 1px solid #ddd;
  padding: 10px 18px !important; /* Increased by 2px */
  height: 38px !important;
  line-height: 28px !important;
  font-size: 14px !important;
  vertical-align: middle !important;
}

tr {
  height: 38px !important; /* Force row height */
  min-height: 38px !important;
  max-height: 38px !important;
}

.p-button, .p-inputswitch, .p-dropdown {
  min-height: 30px !important;
  height: 30px !important;
  font-size: 14px !important;
  padding: 0 10px !important;
}

.p-multiselect {
  min-height: 30px !important;
  height: 40px !important;
  font-size: 14px !important;
  padding: 0 10px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
}

.dialog-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.table-bordered th, .table-bordered td {
  text-align: center;
  vertical-align: middle;
}

.p-multiSelect {
  width: 100%;
}

.p-button-raised {
  margin: auto;
}

.single-line-header {
  white-space: nowrap;
  text-align: center;
}

.single-line-cell {
  display: flex;
  align-items: center;
  gap: 0.5em;
  justify-content: center;
  white-space: nowrap;
  min-height: 30px !important;
  height: 30px !important;
  align-items: center !important;
}`, "",{"version":3,"sources":["webpack://./src/components/assignmentgrid/assignmentgrid.component.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,6BAAA;AACF;;AAEA;EACE,0BAAA;EACA,kBAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EACA,kBAAA;AACJ;;AAGA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,mBAAA;EACA,gBAAA;AAAF;;AAME;EACE,iBAAA;AAHJ;AAME;EACE,iBAAA;AAJJ;AAOE;EACE,YAAA;EACA,iBAAA;AALJ;AAQE;EACE,WAAA;EACA,kBAAA;AANJ;;AAWA;EACE,qBAAA;AARF;;AAYE;EACE,YAAA;AATJ;AAYE;EACE,uBAAA;EACA,oBAAA;AAVJ;AAaE;EACE,gBAAA;EACA,iBAAA;EACA,oBAAA;AAXJ;AAcE;EACE,SAAA;AAZJ;;AAgBA;EACE,eAAA;AAbF;;AAgBA;EACE,yBAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,kBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,cAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,yBAAA;EACA,YAAA;AAbF;;AAeC;EACC,sBAAA;EACA,6BAAA,EAAA,qBAAA;EACA,uBAAA;EACA,4BAAA;EACA,0BAAA;EACA,iCAAA;AAZF;;AAeA;EACE,uBAAA,EAAA,qBAAA;EACA,2BAAA;EACA,2BAAA;AAZF;;AAeA;EACE,2BAAA;EACA,uBAAA;EACA,0BAAA;EACA,0BAAA;AAZF;;AAeA;EACC,2BAAA;EACC,uBAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,6BAAA;AAZF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AAZF;;AAeA;EACE,kBAAA;EACA,sBAAA;AAZF;;AAeA;EACE,WAAA;AAZF;;AAeA;EACE,YAAA;AAZF;;AAeA;EACE,mBAAA;EACA,kBAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,8BAAA;AAZF","sourcesContent":[".col {\r\n  border-right: 1px solid #eee;\r\n  padding: 0.5em;\r\n  height: 100%;\r\n  word-wrap: break-word;\r\n  align-items: center;\r\n  vertical-align: middle;\r\n}\r\n\r\n.data-row {\r\n  font-size: 0.9em;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\ndiv.row-header {\r\n  border-top: 1px solid #ddd;\r\n  margin-top: 0.75em;\r\n  margin-bottom: 0;\r\n\r\n  .col {\r\n    font-weight: 600;\r\n    border-color: #ddd;\r\n  }\r\n}\r\n\r\n.in-list {\r\n  width: 100%;\r\n  font-weight: 500;\r\n  margin-bottom: 0;\r\n  margin-top: 5px;\r\n}\r\n\r\n.list-sub-item {\r\n  margin-left: .25em;\r\n  font-weight: 500\r\n}\r\n\r\n\r\ndiv.btn-container {\r\n\r\n  &.labeled {\r\n    padding-top: 20px;\r\n  }\r\n\r\n  &.labeled-sm {\r\n    padding-top: 25px;\r\n  }\r\n\r\n  &.right {\r\n    float: right;\r\n    margin-left: 15px;\r\n  }\r\n\r\n  &.left {\r\n    float: left;\r\n    margin-right: 15px;\r\n  }\r\n}\r\n\r\n\r\n.ui-paginator-page {\r\n  padding: 0 !important;\r\n}\r\n\r\n:host ::ng-deep {\r\n  .ui-dataview .ui-dataview-header {\r\n    border: none;\r\n  }\r\n\r\n  .ui-dataview-content.ui-widget-content {\r\n    border-width: 1px 0 0 0;\r\n    padding: 0 0 0.5em 0;\r\n  }\r\n\r\n  .ui-dataview-header.ui-widget-header.ui-corner-top {\r\n    border-left: 0px;\r\n    border-right: 0px;\r\n    padding: 0.5em 0 0 0;\r\n  }\r\n\r\n  .ui-paginator-bottom {\r\n    border: 0;\r\n  }\r\n}\r\n\r\n.d-sort:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.selected-col {\r\n  background-color: #007ad9;\r\n  color: white !important;\r\n}\r\n\r\n.pi-sort, .pi-sort-up, .pi-sort-down {\r\n  margin-left: 0.5vh;\r\n}\r\n\r\n.pi-sort:hover {\r\n  cursor: pointer;\r\n  color: #000000;\r\n}\r\n\r\n.d-center {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\ntr:hover {\r\n  background-color: #330aea;\r\n  color: white;\r\n}\r\n td,  th {\r\n  border: 1px solid #ddd;\r\n  padding: 10px 18px !important; /* Increased by 2px */\r\n  height: 38px !important;\r\n  line-height: 28px !important;\r\n  font-size: 14px !important;\r\n  vertical-align: middle !important;\r\n}\r\n\r\ntr {\r\n  height: 38px !important; /* Force row height */\r\n  min-height: 38px !important;\r\n  max-height: 38px !important;\r\n}\r\n\r\n.p-button, .p-inputswitch, .p-dropdown {\r\n  min-height: 30px !important;\r\n  height: 30px !important;\r\n  font-size: 14px !important;\r\n  padding: 0 10px !important;\r\n}\r\n\r\n.p-multiselect {\r\n min-height: 30px !important;\r\n  height: 40px !important;\r\n  font-size: 14px !important;\r\n  padding: 0 10px !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  text-align: center !important;\r\n}\r\n\r\n.dialog-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  height: 100%;\r\n}\r\n\r\n.table-bordered th, .table-bordered td {\r\n  text-align: center;\r\n  vertical-align: middle;\r\n}\r\n\r\n.p-multiSelect {\r\n  width: 100%;\r\n}\r\n\r\n.p-button-raised {\r\n  margin: auto;\r\n}\r\n\r\n.single-line-header {\r\n  white-space: nowrap;\r\n  text-align: center;\r\n}\r\n\r\n.single-line-cell {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5em;\r\n  justify-content: center;\r\n  white-space: nowrap;\r\n  min-height: 30px !important;\r\n  height: 30px !important;\r\n  align-items: center !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
